<template>
  <animated-number
    :value="value"
    :formatValue="formatValue"
    :duration="500"
  />
</template>

<script>
import AnimatedNumber from 'animated-number-vue'

export default {
  components: {
    AnimatedNumber
  },
  props: {
    value: {
      required: true
    },
    decimals: {
      default: 0,
      required: false,
      type: Number
    }
  },
  methods: {
    formatValue(value) {
      return value.toFixed(this.decimals)
    }
  }
}
</script>
